import { Link } from "react-router-dom";
import MicroSiteLayout from "@/components/microsite/MicroSiteLayout";
import { Button } from "@/components/ui/button";
import { useDomainBranding } from "@/hooks/useDomainBranding";

const MicroSiteNotFound = () => {
  const brand = useDomainBranding();
  return (
    <MicroSiteLayout title="Page not found" description="Page not found" canonicalPath="/404">
      <section className="py-20 bg-background text-center">
        <div className="container mx-auto px-4 max-w-xl">
          <h1 className="text-5xl font-heading font-bold text-foreground mb-3">404</h1>
          <p className="text-muted-foreground mb-6">
            That page doesn't exist on {brand.siteName}. Try one of the links below.
          </p>
          <div className="flex flex-wrap justify-center gap-3">
            <Link to="/"><Button>Home</Button></Link>
            <Link to="/services"><Button variant="outline">Services</Button></Link>
            <Link to="/quick-estimate"><Button variant="outline">Free Estimate</Button></Link>
            <Link to="/contact"><Button variant="outline">Contact</Button></Link>
          </div>
        </div>
      </section>
    </MicroSiteLayout>
  );
};

export default MicroSiteNotFound;
